import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

import ddsu5168TwoPoleImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_2p_product.png';
import ddsu5168FourPoleImg from '../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p.png';
import dtsu5168Img from '../../../assets/product-interaction/dtsu5168/dtsu5168_direct.png';
import ge400Img from '../../../assets/product-interaction/ddsu5168-4p/ge400.png';
import joys550Img from '../../../assets/product-interaction/joys550/joys550_product.png';

const products = [
  {
    model: 'DDSU5168',
    name: '单相导轨式电能表（2P）',
    image: ddsu5168TwoPoleImg,
    imageAlt: 'DDSU5168 单相导轨式电能表 2P',
    badge: '2P',
    tags: ['RS485', '4G', 'LoRa'],
    path: '/product/ddsu5168'
  },
  {
    model: 'DDSU5168',
    name: '单相导轨式电能表（4P）',
    image: ddsu5168FourPoleImg,
    imageAlt: 'DDSU5168 单相导轨式电能表 4P',
    badge: '4P',
    tags: ['RS485', '4G'],
    path: '/product/ddsu5168-4p'
  },
  {
    model: 'DTSU5168',
    name: '三相导轨式电能表（7P）',
    image: dtsu5168Img,
    imageAlt: 'DTSU5168 三相导轨式电能表 7P',
    badge: '7P',
    tags: ['RS485', '直接式', '互感式'],
    path: '/product/dtsu5168'
  },
  {
    model: 'GE400',
    name: '智能计量母表网关',
    image: ge400Img,
    imageAlt: 'GE400 智能计量母表网关',
    badge: '母表',
    tags: ['RS485', '4G', '蓝牙'],
    path: '/product/ge400'
  },
  {
    model: 'JOYS550',
    name: '智能远传水表',
    image: joys550Img,
    imageAlt: 'JOYS550 智能远传水表',
    badge: '水表',
    tags: ['4G', '远传', '冷水表'],
    path: '/product/joys550'
  }
];

const ProductInteractionList = () => {
  useEffect(() => {
    document.title = '产品互动中心｜源一物联';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="product-interaction-list">
      <header className="product-list-header">
        <div className="product-list-header-content">
          <span className="product-list-kicker">PRODUCT CENTER</span>
          <h1>产品互动中心</h1>
          <p>选择产品，查看使用说明与专业接线图</p>
        </div>
      </header>

      <section className="product-list-content" aria-label="产品列表">
        <div className="product-card-grid">
          {products.map((product) => (
            <Link
              className="product-card"
              to={product.path}
              key={`${product.model}-${product.name}`}
              aria-label={`查看 ${product.model} ${product.name}`}
            >
              <div className="product-card-image">
                <img                  
                  src={product.image}
                  alt={product.imageAlt}
                />
                <span className="product-card-pole">
                  {product.badge}
                </span>
              </div>
              <div className="product-card-body">
                <span className="product-card-model">{product.model}</span>
                <h2>{product.name}</h2>
                <div className="product-card-footer">
                  <div className="product-card-tags">
                    {product.tags.map((tag) => <span key={tag}>{tag}</span>)}
                  </div>
                  <span className="product-card-arrow" aria-hidden="true">→</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default ProductInteractionList;
